import { makeStyles } from '@material-ui/core/styles'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export default makeStyles(theme => ({
  chip: {
    fontSize: fonts.fontSize.SS,
    fontWeight: fonts.fontWeight.bold
  },
  success: {
    backgroundColor: colors.primary
  },
  error: {
    backgroundColor: colors.redDark
  },
  default: {
    backgroundColor: colors.lightGrey4
  },
  fontWhite: {
    color: colors.white
  },
  fontBlack: {
    color: colors.black
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  collaborator: {
    width: 'max-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: fonts.fontSize.S
  },
  listItemIcon: {
    minWidth: 35,
    padding: 5,
    marginRight: 15,
    background: colors.lightGrey,
    borderRadius: '50%'
  },
  emptyMessage: {
    textAlign: 'center'
  },
  item: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: colors.lightGrey3
    },
    '& > *': {
      color: `${ colors.black } !important`,
      '& span': {
        fontSize: `${ fonts.fontSize.S }px !important`,
        fontWeight: fonts.fontWeight.bold
      },
      '& p': {
        fontSize: `${ fonts.fontSize.SSS }px !important`,
        color: `${ colors.lightGrey4 } !important`
      }
    }
  },
  selectedItem: {
    backgroundColor: colors.backgroundHtml
  },
  loadingItems: {
    opacity: 0.8
  },
  loader: {
    position: 'absolute',
    marginTop: '0px !important'
  },
  actionItem: {
    '& > *': {
      '& span': {
        fontWeight: fonts.fontWeight.regular
      }
    },
    '&:hover': {
      '& > *': {
        color: `${ colors.primary } !important`
      }
    }
  },
  disabled: {
    opacity: 0.5
  },
  overflowTableContainer: {
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      marginTop: 16
    }
  }
}))
